import { Button, Input, InputNumber, message, Modal, Select } from "antd";
import React, { CSSProperties, useEffect, useState } from "react";
import {
  useCountryStruct,
  useCreateWarehouse,
  useGetWarehouseById,
} from "../../api/admin";
import { DeleteOutlined } from "@ant-design/icons";
import {
  useCreateFarmingStage,
  useGetFarmingStageById,
  useUpdateFarmingStage,
} from "../../api/farming_stage";

type FarmingStageModalProps = {
  open: boolean;
  selectedId?: number;
  hideModal: () => void;
};

interface ITag {
  key: string;
  value: string;
}

const wrapper: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 10,
  marginTop: 25,
};
const label: CSSProperties = {
  fontSize: 15,
  color: "#C2CDD0",
};

const value: CSSProperties = {
  color: "#8590A3",
  fontWeight: 500,
  fontSize: 16,
};

const FarmingStageModal: React.FC<FarmingStageModalProps> = ({
  open,
  selectedId,
  hideModal,
}) => {
  const { TextArea } = Input;
  const { data } = useCountryStruct();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState<ITag[]>([]);

  const [tagKey, setTagKey] = useState<string>();
  const [tagValue, setTagValue] = useState<string>();

  const { mutateAsync: createCenter, isPending } = useCreateFarmingStage();
  const {
    mutateAsync: updateStage,
    isPending: updating,
    isSuccess: updated,
  } = useUpdateFarmingStage();
  const { data: selectedWarehouse, refetch } = useGetWarehouseById(selectedId);
  const [countryId, setCountryId] = useState(-1);
  const { data: selectedStage } = useGetFarmingStageById(selectedId);

  useEffect(() => {
    if (selectedId) {
      refetch();
    } else {
      resetForm();
    }
  }, [selectedId]);

  useEffect(() => {
    if (
      selectedStage &&
      selectedStage.data &&
      selectedStage.data.data.length > 0
    ) {
      setName(selectedStage.data.data[0].stageName);
      setDescription(selectedStage.data.data[0].description);
      // const _data = JSON.parse(selectedStage.data.data[0].detail);

      // setTags([_data])

      const val = Object.entries(
        JSON.parse(selectedStage.data.data[0].detail || "{}"),
      ).map((m: any) => {
        return { key: m[0], value: m[1] };
      });

      setTags(val);
    }
  }, [selectedStage]);

  const handleInsertTag = () => {
    if (tagKey && tagValue) {
      const _tag = tags.find((tag) => tag.key === tagKey);

      if (!_tag) {
        setTags((prev) => [...prev, { key: tagKey, value: tagValue }]);
        setTagKey(undefined);
        setTagValue(undefined);
      }
    }
  };

  const handleRemoveTag = (key: string) => {
    console.log(key, tags);
    if (key) {
      const _tags = tags.filter((tag) => tag.key !== key);
      setTags(_tags);
    }
  };

  const onsubmit = async () => {
    if (selectedId === -1) {
      try {
        if (name && description && tags) {
          const data = {
            stageName: name,
            description,
            detail: JSON.stringify(tags),
          };

          const result = await createCenter(data);

          if (result && result.status === 200) {
            message.success("Farming stage created successfully");
          }
        }
      } catch (err: any) {
        message.error("Operation failed");
      }
    } else {
      try {
        if (selectedId && selectedId > 0) {
          const result = await updateStage({
            id: selectedId,
            stage: {
              stageName: name,
              description,
              detail: JSON.stringify(tags),
            },
          });

          if (
            result &&
            result.data &&
            result.data.data &&
            result.data.data.id
          ) {
            message.success("Farming stage updated successfully");
          }
        }
      } catch (err: any) {
        message.error("Operation failed");
      }
    }
    hideModal();
  };

  const resetForm = () => {};

  return (
    <Modal
      afterClose={resetForm}
      width={800}
      title={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 27.43,
            color: "black",
          }}
        >
          {selectedId !== -1 ? "Edit Farming-Stage" : "Create Farming-Stage"}
        </div>
      }
      open={open}
      centered
      onOk={onsubmit}
      // okText={isPending ? 'Saving...' : 'Ok'}
      // okButtonProps={{ disabled: isPending }}
      onCancel={hideModal}
      closable
    >
      <div className="flex-col md:flex justify-between gap-4">
        <div
          className="md:w-[50%]"
          style={{
            fontFamily: "Poppins",
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          <Input
            placeholder="Insert farming-stage name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextArea
            rows={4}
            placeholder="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <div
          className="md:px-[50px] items-center"
          style={{
            display: "flex",
            flexDirection: "column",
            border: "1px solid #E6EEF6",
            borderRadius: 4,
            gap: 12,
            paddingTop: 0,
            paddingBottom: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              marginTop: -15,
            }}
          >
            {tags &&
              tags.map((tag: ITag) => (
                <div
                  key={tag.key}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #DCE2E4",
                    paddingTop: 20,
                    paddingBottom: 5,
                  }}
                >
                  <div className="text-black">{tag.key}</div>
                  <div className="text-black">
                    {tag.value}{" "}
                    <DeleteOutlined
                      style={{ color: "red" }}
                      onClick={() => handleRemoveTag(tag.key)}
                    />
                  </div>
                </div>
              ))}

            {/* {tags && tags.length > 0 && Object.entries(tags[0]).map((tag: any) => {
                            return (
                                <div key={Object.keys(tag)[0]} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', borderBottom: '1px solid #DCE2E4', paddingTop: 20, paddingBottom: 5 }}>
                                    <div style={label}>{tag.key}</div>
                                    <div style={value}>{tag[1]} <DeleteOutlined style={{ color: 'red' }} onClick={() => handleRemoveTag(tag[0])} /></div>
                                </div>
                            )
                        })} */}
          </div>
          <div
            className="flex justify-between md:flex-row"
            style={{
              gap: 12,
              width: "100%",
            }}
          >
            <div className="md:w-[50%]" style={{ ...wrapper, marginTop: 15 }}>
              <div style={label}>Key</div>
              <Input
                value={tagKey}
                onChange={(e) => setTagKey(e.target.value)}
                placeholder="Insert key"
              />
            </div>

            <div style={{ ...wrapper, width: "50%", marginTop: 15 }}>
              <div style={label}>Value</div>
              <Input
                value={tagValue}
                onChange={(e) => setTagValue(e.target.value)}
                placeholder="Insert value"
              />
            </div>
          </div>
          <Button style={{ width: 150 }} onClick={handleInsertTag}>
            Add new tag
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default FarmingStageModal;
